<template lang="pug">
.grid-filter
  p.column-title(v-if='!params.editMode') {{ columnTitle }}
  ed-input(:placeholder='t("Search")'
          v-model='text'
          search
          :ref="'input'"
  )
  ed-radio(name='fxOption' :options='fxOptions' v-model='fxOption' @click='$nextTick(updateScroll)')
  ul.list(:endpoint='api.$.settings.currenciesFilter', :class='{ "edit": params.editMode }' v-show='fxOption.value !== "Keep-"')
    .alert.alert-danger(v-if='errorMessage' role='alert') {{ errorMessage }}
    ed-radio(name='currencyOption' :options='filteredOptions' v-model='currency' @click='click')

  ed-button.btn.btn-actionbar(@click='apply' v-if='!params.editMode') {{ t("Apply") }}
  | &nbsp;
  | &nbsp;
  a(href='#' @click.prevent='clear' v-if='!params.editMode')
    u {{ t("clear filter") }}
</template>

<script>

import {i18n} from '@/lang/lang'
import PerfectScrollbar from 'perfect-scrollbar'

export default {
  props: ['init'],

  beforeCreate() {
    this.api = global.app.api
  },

  data() {
    return {
      options: [],
      test: '',
      formattedList: null,
      text: '',
      columnTitle: '',
      errorMessage: '',

      fxOptions: [
        { label: 'Convert results to selected currency', value: 'Convert-' },
        { label: 'Filter results to selected currency', value: 'Filter-' },
        { label: 'Keep results in original currency', value: 'Keep-' }
      ],
      fxOption: {},
      currency: {}
    }
  },

  computed: {
    filteredOptions() {
      if (!this.params.editMode) this.$nextTick(this.updateScroll)
      if (this.options) {
        return this.options.filter(option => {
          option.label.toLowerCase().includes(this.text.toLowerCase())
            ? option.hide = false
            : option.hide = true
          return true
        })
      }
    }
  },

  created() {
    this.params = this.params || this.init

    let column = this.params.colDef
    this.columnTitle = column.headerName

    this.init && this.fetchOptions()
  },

  mounted() {
    //
  },

  methods: {
    afterGuiAttached() {
      this.fetchOptions()

      if (!this.params.editMode) {
        const viewport = this.$el.querySelector('.list')
        setTimeout(() => (this.ps = new PerfectScrollbar(viewport, { minScrollbarLength: 20 })))
      }

      this.fxOption = this.fxOptions[2]
    },

    t: (key) => i18n.t(key),

    clearOptions: key => (key.status = false) && 0 || key,

    getModel: function() {
      return {
        filter: this.formattedList || (this.text && ''),
        type: 'Currency'
      }
    },

    setModel: function(model) {
      if (model && model.filter) {
        this.text = model.filter
      }
      if (model === null) {
        this.text = ''
        this.formattedList = null
        this.options.forEach(option => (option.status = false))
      }
    },

    isFilterActive: function() {
      return this.text !== null && this.text !== undefined && this.text !== '' && false
    },

    fetchOptions() {
      let list = this
      let column = this.params.colDef
      let options = []

      if (column.options) {
        //
        this.options = this.params.editMode ? column.options : column.options.map(typeof column.closeFilter === 'undefined' ? this.clearOptions : k => k)
      } else {
        //
        // Fetch the options from the api
        //
        this.api.forms.post(this.api.$.settings.currenciesFilter, {
          q: ''
        }).then(r => {
          if (r) {
            let $list = r.data.Data

            $list && $list.filter((k, v) => options.push({
              label: k.Value,
              value: k.Key,
              status: false
            }))

            this.options = options
            column.options = options
          } else {
            list.errorMessage = 'Try again later'
          }
        })
      }
    },

    getOptions() {
      if (this.fxOption.value === 'Keep-') return null
      if (this.fxOption.value && this.currency.value) {
        return `${this.fxOption.value}${this.currency.value}`
      }
    },

    apply() {
      this.formattedList = this.getOptions()
      this.params.filterChangedCallback()
    },

    clear() {
      this.setModel(null)
    },

    updateScroll() {
      this.ps && this.ps.update()
    },

    // edit
    click(e) {
      this.$emit('click', e)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.list {
  list-style: none;
  padding: 0;
  min-height: 50px;
  max-height: 157px;
  overflow: auto;
  position: relative;
  margin-left: -7px;
  padding-left: 5px;
  margin-right: -7px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  &.edit {
    max-height: initial;
  }
  .alert {
    margin-right: 5px;
  }
}

.form-control,
.form-group .form-control {
  @include form-field;
}

.grid-filter {
  position: relative;
   &:before {
    content: '';
    position: absolute;
    bottom: 34px;
    left: -8px;
    width: 108%;
    height: 7px;
    box-shadow: inset 0 -2px 4px rgba(0, 0, 0, 0.1);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/filters/money.vue